{
  "version": "v4.3.0",
  "name": "PoolUser",
  "bytecode": "08014198010009140840b7d30719041916000c304c09a000a001a002a003a004a005a006a00702b21301640c130164170a170914010016051609160a13c41bc16d674ec800001601c9a10014010116051609160a13c41bc16d674ec800001601c9a10114010216051609160a13c41bc16d674ec800001601c9a102b21602160316041605160716081307640c130164170c170b1401031606160b160cc1a107060c0c0f0da0070104170d061341f40c0f0da0070104170e06134bb80c0f0da0070104170f061367100c0f0da00701041710a00071a00171334c06a0001711a001a1001611a101a00171a00271334c06a0011712a002a1011612a102a00071a00171334c06a0001713a001a1001613a101cda000160d13c9010000000000000000000000001400110da0070105a103a000a001160e13c9010000000000000000000000001400110da0070105a104a000a002160f13c9010000000000000000000000001400110da0070105a105a001a002161013c9010000000000000000000000001400110da0070105a106a000a001a002a003a004a005a006a00702",
  "codeHash": "9e1114eb366a5aaf1730e3b16068a672c09da46c4e5111267129c5a0bceeaa97",
  "fieldsSig": {
    "names": [
      "token0",
      "token1",
      "token2",
      "pool0",
      "pool1",
      "pool2",
      "pool3",
      "factory"
    ],
    "types": [
      "ByteVec",
      "ByteVec",
      "ByteVec",
      "Pool",
      "Pool",
      "Pool",
      "Pool",
      "PoolFactory"
    ],
    "isMutable": [
      true,
      true,
      true,
      true,
      true,
      true,
      true,
      true
    ]
  },
  "eventsSig": [],
  "functions": [
    {
      "name": "deploy",
      "paramNames": [
        "counter",
        "payer",
        "pool_",
        "position_",
        "tick_",
        "word_",
        "factory_",
        "config_",
        "dexAccount_"
      ],
      "paramTypes": [
        "U256",
        "Address",
        "ByteVec",
        "ByteVec",
        "ByteVec",
        "ByteVec",
        "ByteVec",
        "ByteVec",
        "ByteVec"
      ],
      "paramIsMutable": [
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false,
        false
      ],
      "returnTypes": [
        "ByteVec",
        "ByteVec",
        "ByteVec",
        "Pool",
        "Pool",
        "Pool",
        "Pool",
        "PoolFactory"
      ]
    }
  ],
  "constants": [],
  "enums": []
}